import React, { useEffect, useRef, useState, useMemo } from "react";
import "./EnrolledStudents.css";
import { Link, useNavigate } from "react-router";
import search_bar from "../../../../../../assets/images/search.svg";
import sort from "../../../../../../assets/images/sort.png";
import DataTableListing from "../../../../../../components/DataTableListing/DataTableListing.jsx";
import BackButton from "../../../../../../components/BackButton/BackButton";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../../../features/auth/AuthContext.js";
import { getAccessControlRole } from "../../../../../../state/actions/getAccessControlRoleAction";
import { getTeacherAndEnrolled } from "../../../../../../state/actions/getTeacherAndEnrolledListAction";
import defaultAvatar from "../../../../../../assets/images/Teacher_profile.png";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton.jsx";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";
import EnrollmentResponsiveCards from "../../../../../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards.jsx";


const BASE_GRADE_OPTIONS = [
  { label: "All", value: "" },
  { label: "Pre-Kindergarten", value: "1" },
  { label: "Kindergarten", value: "2" },
  { label: "Grade 1", value: "3" },
  { label: "Grade 2", value: "4" },
  { label: "Grade 3", value: "5" },
  { label: "Grade 4", value: "6" },
  { label: "Grade 5", value: "7" },
  { label: "Grade 6", value: "8" },
  { label: "Grade 7", value: "9" },
  { label: "Grade 8", value: "10" },
  { label: "Grade 9", value: "11" },
  { label: "Grade 10", value: "12" },
  { label: "Grade 11", value: "13" },
  { label: "Grade 12", value: "14" },
];

const PROSCHOOL_EXTRA_GRADES = [
  { label: "Undergraduate", value: "15" },
  { label: "Graduate", value: "16" },
  { label: "Masters", value: "17" },
  { label: "Doctorate", value: "18" },
  { label: "Post Doctorate", value: "19" },
  { label: "Corporate", value: "20" },
];


const sortOptions = [
  { label: "Name : A - Z", value: "Name:A-Z" },
  { label: "Name : Z - A", value: "Name:Z-A" },
  { label: "Grade : Low - High", value: "Grade:low_to_high" },
  { label: "Grade : High - Low", value: "Grade:high_to_low" },
  { label: "Newest First", value: "Newest" },
  { label: "Oldest First", value: "Oldest-First" },
];

export default function EnrolledStudents({ isPreview = false }) {
  const [activeTab, setActiveTab] = useState("assigned");
  const [searchAssigned, setSearchAssigned] = useState("");
  const [searchMyStudents, setSearchMyStudents] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [gradeOpen, setGradeOpen] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState("");

  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortValue, setSortValue] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useAuth();

  const sortRef = useRef(null);
  const gradeRef = useRef(null);

  const globalState = useSelector((state) => state.globalState);
  const isMarketplace = globalState?.enabled_modules?.includes("marketplace");
  console.log(" isMarketplace", isMarketplace);

  const GradeOptions = useMemo(
  () => (isMarketplace ? [...BASE_GRADE_OPTIONS, ...PROSCHOOL_EXTRA_GRADES] : BASE_GRADE_OPTIONS),
  [isMarketplace]
);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const teacherId = globalState?.teacher_details?.data?.teacher_id;
  const RoleTypeRaw =
    globalState?.teacher_details?.data?.teacher_department_roles;

  const RoleType = RoleTypeRaw
    ? RoleTypeRaw.split(" ").length > 1
      ? RoleTypeRaw.split(" ")
          .map((word) => word.charAt(0).toUpperCase())
          .join("")
          .toLowerCase()
      : RoleTypeRaw
    : "";

  const { roleList: advisor, isLoading, count: assignedCount } = useSelector(
    (state) => state.getAccessControlRoleList,
  );

  const { teacherList, count: myCount } = useSelector(
    (state) => state.getTeacherAndEnrolled,
  );

  const searchValue = activeTab === "assigned" ? searchAssigned : searchMyStudents;
  /* ---------------- SEARCH DEBOUNCE ---------------- */

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchValue.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [searchValue]);

  /* ---------------- RESET PAGE WHEN FILTER CHANGES ---------------- */

  useEffect(() => {
    setCurrentPage(1);
  }, [sortValue, debouncedSearch, selectedGrade, activeTab]);

  /* ---------------- CLICK OUTSIDE DROPDOWNS ---------------- */

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortRef.current && !sortRef.current.contains(e.target)) {
        setShowSortMenu(false);
      }

      if (gradeRef.current && !gradeRef.current.contains(e.target)) {
        setGradeOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ---------------- INITIAL LOAD ---------------- */

  useEffect(() => {
    if (!token) return;

    dispatch(getTeacherAndEnrolled(token, "enrolled_students", teacherId, undefined,   // sort
    undefined,   // grade
    undefined,   // search
    undefined,   // school_id
    undefined,   // subject_id
    undefined,
    1
  ));
  }, [token, dispatch, teacherId, RoleType]);

  /* ---------------- SERVER API CALL ---------------- */
  useEffect(() => {
    if (!token || !teacherId) return;

    if (activeTab === "assigned") {
      dispatch(
        getAccessControlRole(
          token,
          RoleType,
          "assigned",
          teacherId,
          sortValue || undefined,
          selectedGrade || undefined,
          debouncedSearch || undefined,
          currentPage,
        ),
      );
    } else {
      dispatch(
        getTeacherAndEnrolled(
          token,
          "enrolled_students",
          teacherId,
          sortValue || undefined,
          selectedGrade || undefined,
          debouncedSearch || undefined,
          undefined,
          undefined,
          undefined,
          currentPage,
        ),
      );
    }
  }, [
    activeTab,
    token,
    teacherId,
    RoleType,
    debouncedSearch,
    selectedGrade,
    sortValue,
    currentPage,
    dispatch,
  ]);

  useEffect(() => {
    if (activeTab === "assigned") {
        setDebouncedSearch("");
    } else {
        setDebouncedSearch("");
    }
   
    setCurrentPage(1);
  }, [activeTab]);
  /* ---------------- DATA FORMAT ---------------- */

  const assignedStudents = (advisor ?? []).map((s) => ({
    key: s.student_id,
    name: s.student_name || "",
    studentId: s.student_id,
    grade: s.grade_name || "",
    email: s.email || "",
    assignedOn: s.assigned_date,
    avatar: s.student_profile_pic || defaultAvatar, 
  }));

  const myStudents = (teacherList ?? []).map((s) => ({
    key: s.student_id,
    name: s.student_name || "",
    studentId: s.student_id,
    grade: s.grade_name || "",
    email: s.email || "",
    joinedOn: s.students_join_date,
    avatar: s.student_profile_pic || defaultAvatar ,
  }));

  const tableData = activeTab === "assigned" ? assignedStudents : myStudents;
  const totalCount =
    activeTab === "assigned" ? assignedCount ?? 0 : myCount ?? 0;
  const selectedGradeLabel =
    GradeOptions.find((g) => g.value === selectedGrade)?.label || "All Grades";

  /* ---------------- TABLE COLUMNS ---------------- */

  const columns = [
    {
      key: "name",
      title: "Student Name",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {row.avatar ? (
            <img
              src={row.avatar}
              alt={value}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#94a3b8",
                fontWeight: 600,
              }}
            >
              {value?.charAt(0)}
            </div>
          )}

          <span>{value}</span>
        </div>
      ),
    },

    { key: "studentId", title: "Student ID",  render: (value) => (value),
    headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
    ),  },

    { key: "grade", title: "Grade", render: (value) => (value),
    headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
    ),  
  },

    { key: "email", title: "Email ID" },

    {
      key: activeTab === "assigned" ? "assignedOn" : "joinedOn",
      title: activeTab === "assigned" ? "Assigned On" : "Joined On",
      render: (v) =>
        v
          ? new Date(v)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              .replace(/ (\d{4})$/, ", $1")
          : "-",
    },

    {
      key: "action",
      title: "Action",
      render: (_, row) => (
        <Link
          to={`/student/${row.studentId}`}
          style={{
            color: "#0068FF",
            fontSize: 13.5,
            fontWeight: 500,
            textDecoration: "none",
          }}
        >
          View Profile
        </Link>
      ),
    },
  ];
 const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const day = date.toLocaleString("en-GB", { day: "2-digit" });
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };
  const shouldPaginate = totalCount > 12 && !isPreview;
  return (
    <>    
     <BackButton onClick={() => navigate("/dashboard/home")} buttonName="Back" />

    <div className="enrolled-students-container">
      <h3 className="enrolled-students-title">My Students</h3>
      {/* Tabs */}

      <div className="students-tabs">
        <button
          className={`tab-btn ${activeTab === "assigned" ? "active" : ""}`}
          onClick={() => setActiveTab("assigned")}
        >
          Assigned Students ({assignedCount ?? 0})
        </button>

        <button
          className={`tab-btn ${activeTab === "my" ? "active" : ""}`}
          onClick={() => setActiveTab("my")}
        >
          My Students ({myCount ?? 0})
        </button>
      </div>

      {/* Toolbar */}

      <div className="es-toolbar">
        <div className="search-bar">
          <img src={search_bar} alt="search" />

          <input
            type="text"
            placeholder="Search students..."
            value={searchValue}
            onChange={(e) => {
              if (activeTab === "assigned") {
                setSearchAssigned(e.target.value);
              } else {
                setSearchMyStudents(e.target.value);
              }
            }}
          />
        </div>

        <div className="es-toolbar-right">
                <div style={{ position: "relative" }} ref={gradeRef}>
                <button
                  className="grade-dropdown"
                  onClick={() => setGradeOpen((prev) => !prev)}
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <span>{selectedGradeLabel}</span>

                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginLeft: 8, marginRight: 4 }}>
                  <path
                    d="M2 4L6 8L10 4"
                    stroke="#64748b"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  </svg>
                </button>

                {gradeOpen && (
                  <div className="sort-menu left-0" style={{ minWidth: 170 }}>
                  {GradeOptions.map((option) => (
                    <div
                    key={option.value}
                    // className="sort-options"
                    className={selectedGrade === option.value ? "sort-options text-[#0068FF]" : "sort-options"}
                    onClick={() => {
                      setSelectedGrade(option.value);
                      setCurrentPage(1);
                      setGradeOpen(false);
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Sort */}

          <div style={{ position: "relative" }} ref={sortRef}>
            <button
              className="sort-button"
              onClick={() => setShowSortMenu((prev) => !prev)}
            >
              <img src={sort} alt="sort" />
              Sort
            </button>

            {showSortMenu && (
              <div className="sort-menu">
                {sortOptions.map((option) => (
                  <div
                    key={option.value}
                    className={sortValue === option.value ? "sort-options text-[#0068FF]" : "sort-options"}
                    onClick={() => {
                      setSortValue(option.value);
                      setCurrentPage(1);
                      setShowSortMenu(false);
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Table */}

       {isMobile ? (
          <EnrollmentResponsiveCards
            data={
              tableData?.map((student) => ({
                id: student.studentId,
                name: student.name,
                profilePic: student.avatar,
                grade: student.grade,
                email: student.email,
                joinDate: student.joinedOn
                  ? formatDate(student.joinedOn)
                  : student.assignedOn
                  ? formatDate(student.assignedOn)
                  : "—",
                active: student.active,
                user_id: student.studentId,
                is_special_ability: student.is_special_ability,
              })) || []
            }
            showActions={false}
            userType="student"
            onCardClick={(item) => navigate(`/student/${item.id}`)}
          />
        ) : (
          <DataTableListing
            columns={columns}
            dataSource={tableData}
            rowKey="key"
            loading={isLoading}
            pagination={
              shouldPaginate
                ? {
                    currentPage,
                    total: totalCount,
                    pageSize: 12,
                    onChange: setCurrentPage,
                  }
                : false
            }
            checkable={false}
            emptyText={
              searchValue
                ? "No Students found"
                : activeTab === "assigned"
                ? "No students Assigned yet"
                : "No students enrolled yet"
            }
            LineTwoText={
              searchValue
                ? ""
                : activeTab === "assigned"
                ? "Once Students are assigned, they'll appear here"
                : "Once Students are enrolled, they'll appear here"
            }
          />
        )}


      <FloatingAIButton
        onClick={() => {
        dispatch(setDrawerState(!chatDrawerState.isOpen));
        dispatch(setIsWebAllowed(true));
        dispatch(setQueryMetaData(null));
        }}
      />
    </div>
    </>
  );
}
